// @packages
import { combineReducers } from "redux";
import updateDataGrid from "./updateDataGrid";

const rootReducer = combineReducers({ updateDataGrid });

export default rootReducer;
